import React from "react";
import { ErrorBoundary } from "./components/ErrorBoundary";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import App from "./App";
import { store, persistor } from "./state/store";
import { DarkModeProvider } from "./contexts/DarkModeContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import { TourProvider } from "./contexts/TourContext";
import { AnnouncementProvider } from "./contexts/AnnouncementContext";
import { NotificationProvider } from "./contexts/NotificationContext";
import { WhatsNewProvider } from "./contexts/WhatsNewContext";
import "./index.css";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ThemeProvider>
          <DarkModeProvider>
            <TourProvider>
              <AnnouncementProvider>
                <NotificationProvider>
                  <WhatsNewProvider>
                    <ErrorBoundary>
                      <App />
                    </ErrorBoundary>
                  </WhatsNewProvider>
                </NotificationProvider>
              </AnnouncementProvider>
            </TourProvider>
          </DarkModeProvider>
        </ThemeProvider>
      </PersistGate>
    </Provider>
  </React.StrictMode>
);

// Register Service Worker for PWA
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js")
      .then(reg => {
        console.log("SW registered:", reg.scope);
      })
      .catch(err => {
        console.error("SW registration failed:", err);
      });
  });
}
